/**
 * GENERATED by scripts/generate-bundled-families.ts - do not edit by hand.
 *
 * The Word family names a document can curate via createSuperDocFonts({ include / exclude }), mirrored
 * from @superdoc/font-system's runtime curation set (every logical family the resolver substitutes to a
 * bundled face, including category fallbacks like Verdana). A name outside this set is a typo or an
 * unbundled font, so createSuperDocFonts rejects it instead of silently dropping the intended fonts.
 */
export const BUNDLED_FAMILY_NAMES = Object.freeze([
  'Arial',
  'Arial Black',
  'Arial MT',
  'Arial Narrow',
  'Baskerville Old Face',
  'Bookman Old Style',
  'Brush Script MT',
  'Calibri',
  'Calibri Light',
  'Cambria',
  'Century',
  'Century Gothic',
  'Century Schoolbook',
  'Comic Sans MS',
  'Consolas',
  'Cooper Black',
  'Courier',
  'Courier New',
  'Garamond',
  'Georgia',
  'Gill Sans MT Condensed',
  'Helvetica',
  'ITC Bookman',
  'Lucida Console',
  'Segoe UI',
  'Tahoma',
  'Times',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
] as const);

/**
 * Union of the Word family names the bundled pack can curate, for autocomplete on
 * createSuperDocFonts({ include / exclude }). Those options also accept any string (case- and
 * quote-insensitive, validated at runtime), so a list built from dynamic config still type-checks.
 */
export type BundledFontFamilyName = (typeof BUNDLED_FAMILY_NAMES)[number];
